import {
  emailRegex,
  mobileNumWithOptional91AndPlus91Regex,
  mobileNumWithOptional91Regex,
  panNumRegex,
} from 'Constants'
import { panWithForm60Regex } from 'Constants/regex'
import { INestedQuestionSet } from 'Models/BOB/ResponseModels/Life/QuestionSet'

const personalDetailsRenderObject: {
  form_fields: INestedQuestionSet[]
} = {
  form_fields: [
    {
      max: undefined,
      name: 'Mobile number',
      code: 'contactnumber',
      dropdown: {},
      cover_type: 'Text',
      min: undefined,
      description: '',
      input_type: 'Text',
      hidden: false,
      values: {},
      regex: mobileNumWithOptional91AndPlus91Regex,
    },
    {
      max: undefined,
      name: 'Email',
      code: 'emails',
      dropdown: {},
      cover_type: 'Text',
      min: undefined,
      description: '',
      input_type: 'String',
      hidden: false,
      values: {},
      regex: emailRegex,
    },
    {
      max: undefined,
      name: 'Marital Status',
      code: 'marital_status',
      dropdown: {
        good: 'good',
      },
      cover_type: 'dropdown',
      min: undefined,
      description: '',
      input_type: 'String',
      hidden: false,
      values: {},
    },
    {
      max: 6,
      name: 'Pincode',
      code: 'pincode',
      dropdown: {},
      cover_type: 'Text',
      min: 6,
      description: '',
      input_type: 'String',
      hidden: false,
      values: {},
    },
    {
      max: undefined,
      name: 'City',
      code: 'city',
      dropdown: undefined,
      cover_type: 'Text',
      min: undefined,
      description: '',
      input_type: 'text',
      hidden: false,
      range: false,
      values: {},
    },
    {
      max: undefined,
      name: 'State',
      code: 'state',
      dropdown: undefined,
      cover_type: 'Text',
      min: undefined,
      description: '',
      input_type: 'text',
      hidden: false,
      range: false,
      values: {},
    },
    {
      max: undefined,
      name: 'Pan Card',
      code: 'pancard',
      dropdown: undefined,
      cover_type: 'Text',
      min: undefined,
      description: '',
      input_type: 'pancard',
      hidden: false,
      range: false,
      values: {},
      regex: panWithForm60Regex,
    },
    {
      max: undefined,
      name: 'Address Line 1',
      code: 'address1',
      dropdown: undefined,
      cover_type: 'Text',
      min: undefined,
      description: '',
      input_type: 'text',
      hidden: false,
      range: false,
      values: {},
    },
    {
      max: undefined,
      name: 'Address Line 2',
      code: 'address2',
      dropdown: undefined,
      cover_type: 'Text',
      min: undefined,
      description: '',
      input_type: 'text',
      hidden: false,
      range: false,
      values: {},
    },

    // {
    //   max: undefined,
    //   name: 'Tobacoo User',
    //   code: 'is_tobacco_user',
    //   dropdown: {
    //     Yes: 'Yes',
    //     No: 'No',
    //   },
    //   cover_type: 'switch',
    //   min: undefined,
    //   description: 'Please Enter Tobacoo User',
    //   input_type: 'text',
    //   hidden: false,
    //   range: false,
    //   values: {},
    // },
    {
      max: undefined,
      name: 'Residential Status',
      code: 'residentialStatus',
      dropdown: undefined,
      default: 'Indian',
      cover_type: 'dropdown',
      min: undefined,
      description: '',
      input_type: 'text',
      hidden: false,
      range: false,
      values: {},
    },
    {
      max: undefined,
      name: 'Nationality',
      code: 'nationality',
      dropdown: { 'Non-Indian': 'Non-Indian', Indian: 'Indian' },
      cover_type: 'switch',
      min: undefined,
      description: '',
      hidden: false,
      values: {},
    },
    {
      max: undefined,
      name: 'Do you have any disability that restricts you from providing consent/Signature in the proposal form?',
      code: 'disabilityConsent',
      dropdown: { Yes: 'Yes', No: 'No' },
      cover_type: 'switch',
      min: undefined,
      description: '',
      hidden: false,
      values: {},
    },
  ],
}

export { personalDetailsRenderObject }
